<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import tool from "@/utils/tool";
export default {
  name: "App",
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 5s !important;
}
.circular {
  display: none;
}
// .row--current{
//   background-color: aqua !important;
// }
.el-loading-mask {
  margin: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  position: fixed !important;
  left: 0 !important;
  top: 90px !important;
  background: url("./assets/Images/timg.gif") center center no-repeat #fff !important;
  background-color: rgba(255, 255, 255, 1) !important;
  width: 100vw !important;
  height: 92vh !important;
  z-index: 1000 !important;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/App.vue